import { VideoModal } from '../components/video_modal.js';

export class NodePageLocation extends DrupalBehavior {
  onContent(context) {
    const videoModal = new VideoModal();
    const videos = context.querySelectorAll('.article--teaser--video');
    videoModal.init(videos);
  }
}

DrupalBehavior.register('rush_theme.node_page', 'location', NodePageLocation);
